var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"element-list"},[_c('i',{staticClass:"fas fa-book"}),_c('span',[_vm._v(_vm._s(_vm.bookcase.name))]),_c('SimpleButton',{attrs:{"iconClass":"fas fa-eye","title":"Voir"},on:{"clickButton":_vm.clickButton}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }